import { RELATORIO_FINANCEIRO_ACCESS } from '../constants/modules';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';

/**
 * Quem pode acessar /v2/relatorio-financeiro (menu + tela).
 * Requer module configuration RELATORIO_FINANCEIRO_ACCESS vinculada ao userId logado.
 */
export function canViewFinanceiroReport({ authData, userRole, moduleConfigurations }) {
  if (!authData?.id) return false;

  const role = userRole ?? authData.role;
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(role)) {
    return false;
  }

  return !!moduleConfigurations?.some(
    (m) => m.codigo === RELATORIO_FINANCEIRO_ACCESS && m.userId === authData.id,
  );
}
